/*
 * Copyright (c) 2024 яαvoroηα
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */

import { SCREEN, STORAGE } from '@scripts/utils/constants'
import store from '@scripts/utils/storage'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { gsap } from 'gsap'

class Header {
    namespace: string = 'header'
    toggle: HTMLButtonElement | null
    navigation: HTMLElement | null
    overlay: HTMLElement | null
    timeline?: GSAPTimeline

    constructor() {
        console.log('[%s] bootstrap', this.namespace)

        this.toggle = document.querySelector<HTMLButtonElement>('.banner--toggle-menu')
        this.navigation = document.querySelector<HTMLElement>('.page--aside')
        this.overlay = document.querySelector<HTMLElement>('.page--overlay')
    }

    start() {
        console.log('[%s] start', this.namespace)

        store?.subscribe(() => {
            this.toggleMainMenu()
        })

        this.bootStrapTween()
        this.setEventHandlers()
    }

    bootStrapTween() {
        if (window.innerWidth >= SCREEN.LG) {
            this.clearTimeline()
            enableBodyScroll(document.body)
        } else {
            this.buildTimeline()
            store.dispatch({ type: STORAGE.ACTION_MENU_HIDE })
        }
    }

    buildTimeline() {
        this.timeline = gsap.timeline({
            paused: true,
            onStart: () => disableBodyScroll(document.body),
            onReverseComplete: () => enableBodyScroll(document.body)
        })

        if (this.navigation && this.overlay) {
            this.timeline
                .fromTo(
                    this.overlay,
                    {
                        autoAlpha: 0
                    },
                    {
                        autoAlpha: 1,
                        duration: 0.4,
                        ease: 'none'
                    }
                )
                .fromTo(
                    this.navigation,
                    {
                        yPercent: -100
                    },
                    {
                        duration: 1,
                        ease: 'power2.inOut',
                        yPercent: 0,
                        clearProps: true
                    },
                    0
                )
                .duration(1)
                .reverse()
        }
    }

    clearTimeline() {
        this.timeline?.clear()
        this.navigation && gsap.set([this.navigation], { clearProps: true })
    }

    setEventHandlers() {
        this.toggle?.addEventListener('click', () => {
            store.dispatch({ type: STORAGE.ACTION_MENU_TOGGLE })
        })

        window.addEventListener('resize', () => {
            this.bootStrapTween()
        })
    }

    toggleMainMenu() {
        const { menuVisible } = store.getState()
        this.timeline?.reversed(!menuVisible)
    }
}

export default new Header()
